<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useRegisterSW } from 'virtual:pwa-register/vue'
import Button from '@/components/ui/Button.vue'

const { t } = useI18n()

const { needRefresh, updateServiceWorker } = useRegisterSW({
  immediate: true,
  onRegisteredSW(_url, registration) {
    if (!registration) {
      return
    }
    // Update checks refetch /sw.js in the background; transient failures (deploy
    // propagation, offline) are expected and shouldn't surface as unhandled rejections.
    window.setInterval(() => {
      registration.update().catch(() => {})
    }, 15 * 60 * 1000)

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') {
        registration.update().catch(() => {})
      }
    })
  },
})

function reload() {
  void updateServiceWorker(true)
}
</script>

<template>
  <div
    v-if="needRefresh"
    class="fixed inset-x-0 bottom-0 z-50 p-4 pb-[max(1rem,env(safe-area-inset-bottom))]"
    role="status"
  >
    <div
      class="card-panel mx-auto flex max-w-lg flex-col gap-3 sm:flex-row sm:items-center sm:justify-between"
    >
      <p class="text-sm text-gray-800 dark:text-gray-100">
        {{ t('pwa.updateTitle') }}
      </p>
      <Button
        class="w-full sm:w-auto"
        @click="reload"
      >
        {{ t('pwa.updateAction') }}
      </Button>
    </div>
  </div>
</template>
